import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import ModalBottomSheetUI from '../../components/UI/ModalBottomSheetUI';

const MvmInfo = (props) => {
    const [info, setInfo] = useState({ open: false });

    const closeModal = () => {
        info.open = false;
        setInfo({ ...info });
    }

    return (
        <>
            <i
                className="material-icons prefix"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                    info.open = info.open ? false : true;
                    setInfo({ ...info })
                }}>local_shipping
            </i>
            <ModalBottomSheetUI
                open={info.open}
                maxHeight="65%"
                onClose={closeModal}
                data={
                    <div
                        style={{ wordBreak: 'break-word', fontWeight: 'bold' }}
                        className="sixth-text-color">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            MVM: {props.mvm?.mvmNumber}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            Motorista: {props.mvm?.driverName}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            Placa: {props.mvm?.vehiclePlateNumber}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            Código Fornecedor: {props.mvm?.shippingSupplierId}-{props.mvm?.shippingSupplierCorporateName}
                        </div>
                    </div>
                }
            />
        </>
    );

}

export default (withTranslation()(MvmInfo));